// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray-overlay {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: gray;\n    top: 0px;\n    left: 0px;\n    opacity: .3;\n}\n\n.overlay-spinner {\n    position: fixed;\n    height: 60px;\n    width: 60px;\n    top: calc(50% - 30px);\n    left: calc(50% - 30px);\n}", ""]);
// Exports
module.exports = exports;
